/**
 * Fiyat & Sinyal Alarmlari - kullanicinin ISTEDIGI belirli bir sembol icin
 * tanimladigi ozel kosullar (bkz. Ayarlar ekrani). Mevcut "Elimde Var"
 * bildirimlerinden AYRIDIR: o TUM favori sembollerin herhangi bir sinyalini
 * izler, bu ise TEK bir sembol icin kullanicinin sectigi zaman dilimlerinde
 * Dusus sinyalini ve/veya belirli bir fiyat hedefini izler.
 *
 * SUNUCUDA, KULLANICI BASINA saklanir (GET/POST/DELETE /api/alerts - bkz.
 * backend scanner/user_stores.py). Onceden tarayicinin localStorage'indaydi:
 * ayni cihazi kullanan iki uye birbirinin alarmini goruyordu, alarm baska
 * cihazda gorunmuyordu ve sunucu sekme kapaliyken alarmi kontrol
 * edemiyordu (varligindan haberi yoktu).
 */

import type { PriceAlert as ServerPriceAlert } from "../api/types";

export interface PriceAlert {
  id: string;
  symbol: string;
  /** Dusus sinyali izlenecek zaman dilimleri (bos = sinyal izlenmez). */
  sellTimeframes: string[];
  /** Fiyat hedefi (null = fiyat izlenmez). */
  priceTarget: number | null;
  /** Hedefe HANGI yonden ulasilinca tetiklenecegi - sunucu olusturulurken
   *  mevcut fiyata gore OTOMATIK belirler. */
  priceDirection: "above" | "below" | null;
  createdAt: number;
}

export function fromServer(alert: ServerPriceAlert): PriceAlert {
  return {
    id: alert.id,
    symbol: alert.symbol,
    sellTimeframes: alert.sell_timeframes,
    priceTarget: alert.price_target,
    priceDirection: alert.price_direction,
    createdAt: alert.created_at,
  };
}

/** Eski, tarayicida saklanan alarmlarin anahtari - yalnizca bir kerelik
 *  sunucuya tasima icin okunur, sonra silinir. */
const LEGACY_KEY = "csb.alerts";

export function takeLegacyAlerts(): PriceAlert[] {
  try {
    const raw = localStorage.getItem(LEGACY_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as PriceAlert[]) : [];
  } catch {
    return [];
  }
}

export function clearLegacyAlerts(): void {
  try {
    localStorage.removeItem(LEGACY_KEY);
  } catch {
    /* ozel pencerede erisim reddedilebilir */
  }
}
